/* eslint-disable no-prototype-builtins */

const groupBy = (array: unknown[], criteria: any): any => {
  return array.reduce((obj: any, item: any) => {
    const key =
      typeof criteria === 'function' ? criteria(item) : item[criteria];

    if (!obj.hasOwnProperty(key)) {
      obj[key] = [];
    }

    obj[key].push(item);

    return obj;
  }, {});
};

export default groupBy;
